module.exports = __webpack_public_path__ + "img/question_top_left.6b6da9a7.svg";